import { ConfirmDialog } from 'primereact/confirmdialog';

import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useIdleTimer } from 'react-idle-timer';
import { useAuthentication } from '../../hooks/useAuthentication';
import './idle-tracker.css';
import { showToast } from '../../helpers/showToast';

export const IdleTracker = () => {
  const { t } = useTranslation();
  const { logout, userInfo } = useAuthentication();

  const [remaining, setRemaining] = useState(0);
  const [showPrompt, setShowPrompt] = useState(false);

  const formatRemainingTime = (seconds) => {
    // Calculate minutes and seconds
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // Pad single digit seconds with a leading zero
    const formattedSeconds =
      remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

    // Return formatted time
    return minutes + ':' + formattedSeconds;
  };

  const { reset, getRemainingTime, pause, start } = useIdleTimer({
    // startManually: true,
    startOnMount: false,
    crossTab: true,
    timeout: 15 * 60 * 1000,
    promptBeforeIdle: 2 * 60 * 1000,
    stopOnIdle: true,
    onPrompt: () => {
      setShowPrompt(true);
    },
    onIdle: () => {
      // eslint-disable-next-line no-undef
      logout({ redirect: location.pathname, sessionTimeout: true });
    },
  });

  const tick = useCallback(() => {
    setRemaining(Math.ceil(getRemainingTime() / 1000));
  }, []);
  useEffect(() => {
    setInterval(tick, 1000);
  }, []);

  useEffect(() => {
    if (userInfo?.userId) {
      reset();
      start();
    } else {
      pause();
    }
  }, [userInfo?.userId]);

  useLayoutEffect(() => {
    if (localStorage.getItem('sessionExpired')) {
      setTimeout(() => {
        showToast({
          data: {
            variant: 'error',
            text: t(
              'session-expired',
              'Your session has expired. Please login again.',
            ),
          },
        });
        localStorage.removeItem('sessionExpired');
      }, 1000);
    }
  }, []);
  return (
    <ConfirmDialog
      className="idle-tracker"
      visible={showPrompt}
      onHide={() => {
        reset();
        setShowPrompt(false);
      }}
      message={t('idle.message', { time: formatRemainingTime(remaining) })}
      header={t('idle.youve-been-idle')}
      icon="text-red-500 pi pi-exclamation-triangle"
      acceptLabel={t('idle.stay')}
      accept={() => {
        reset();
      }}
    />
  );
};
